<script>
import every from 'lodash/every'
import values from 'lodash/values'
import { authComputed } from '@state/helpers'
import { agentListComputed, agentListMethods } from '@state/helpers/agent-list'
import SearchPayload from '@utils/searchPayload'
import { ObjectHelper, addParamsToLocation } from '@utils/helpers'
import tableFields from './tableFields'

export default {
  page: {
    title: 'Agent List',
    meta: [{ name: 'description', content: 'The Agent List page.' }],
  },
  data() {
    return {
      items: {},
      searchBody: new SearchPayload.Builder().withSearchName().withSearchMail(),
      fields: tableFields,
      filtered: false,
      openConfirm: false,
      agentIdSelected: {},
      componentKey: 0,
    }
  },
  computed: {
    ...authComputed,
    ...agentListComputed,
    agentListData() {
      return (
        this.getAgentList?.list?.map((item) => {
          item.agent_id = item.id
          return item
        }) || []
      )
    },
    paginationComputed() {
      let paginations = {}
      if (this.getAgentList) {
        paginations = ObjectHelper.removePropertyByKey('list')(
          this.getAgentList
        )
      }
      return paginations
    },
    currentUserComputed() {
      return this.currentUser?.id
    },
    unselectedAll() {
      return every(values(this.agentIdSelected), function(v) {
        return !v
      })
    },
    confirmComputed() {
      if (this.unselectedAll) {
        return 'unselected'
      }
      return 'delete'
    },
  },
  watch: {
    searchBody() {
      addParamsToLocation(this.$route, this.searchBody)
      this.componentKey++
    },
  },
  created() {
    const filter = this.$route.query
    filter.page_no = parseInt(filter.page_no, 10)
    filter.lines = parseInt(filter.lines, 10)
    for (const key in filter) {
      if (key !== 'page_no' && key !== 'lines') {
        if (filter[key] !== '' && filter[key] !== undefined) {
          this.searchBody = filter
          this.filtered = true
        }
      }
    }
    if (filter.page_no > 1) {
      this.searchBody = filter
    }
    this.handleSearchAgent()
  },
  methods: {
    ...agentListMethods,
    showModal() {
      this.openConfirm = !this.openConfirm
    },
    handlePagination(body) {
      this.searchBody = { ...this.searchBody, ...body }
      this.handleSearchAgent()
    },
    handleSorter(key) {
      this.searchBody = { ...this.searchBody, order_by: key }
      this.handleSearchAgent()
    },
    handleFilter(params, reset = false) {
      this.searchBody = { ...this.searchBody, ...params }
      this.handleSearchAgent()
      this.filtered = !reset
    },
    handleSearchAgent() {
      this.fetchingAgentList(this.searchBody)
    },
    goToAddNewPage() {
      this.$router.push({ name: 'agentRegistration' })
    },
    handleSelected(id, value) {
      const temp = { ...this.agentIdSelected }
      temp[id] = value
      this.agentIdSelected = { ...temp }
    },
    viewDetail(id) {
      this.$router.push({
        path: `/panel/agent-list/${id}`,
      })
    },
    submit() {
      const temp = { ...this.agentIdSelected }
      const flag = Object.keys(temp)?.map((key) => {
        if (temp[key]) {
          return key
        }
      })
      Promise.all(
        flag?.map((id) => {
          return this.deleteAgentById({ id })
        })
      ).then((rs) => {
        this.openConfirm = !this.openConfirm
        this.fetchingAgentList(this.searchBody)
        this.agentIdSelected = {}
      })
    },
  },
}
</script>

<template>
  <div>
    <BaseFilterBoxCard
      :key="componentKey"
      :filter-value="searchBody"
      @filter="(p, r) => handleFilter(p, r)"
    />
    <BasePagination
      :paginations="paginationComputed"
      :searching="filtered"
      @activePagination="handlePagination"
    >
      <template v-slot:secondary>
        <CButton
          color="dark"
          variant="outline"
          class="py-0"
          @click="goToAddNewPage"
          >新規登録</CButton
        >
        <CButton
          color="dark"
          variant="outline"
          class="py-0 ml-1"
          @click="showModal"
          >削除</CButton
        >
      </template>
    </BasePagination>
    <BaseTable
      striped
      border
      hover
      :table-fields="fields"
      :data-tables="agentListData"
      @sorterBy="handleSorter"
      @row-clicked="(item) => viewDetail(item.agent_id)"
    >
      <template v-slot:checkbox="{ item }">
        <td class="py-2" @click.stop="() => {}">
          <CInputCheckbox
            v-if="item.agent_id !== 1"
            :checked="agentIdSelected[item.agent_id]"
            color="primary"
            @update:checked="(v) => handleSelected(item.agent_id, v)"
          />
        </td>
      </template>
      <template v-slot:agent_code="{ item }">
        <td>
          {{ item.agent_code }}
        </td>
      </template>
    </BaseTable>
    <BaseModalConfirm
      backdrop-close
      :show.sync="openConfirm"
      :type="confirmComputed"
      :hide-action-button="unselectedAll"
      @closeModal="openConfirm = !openConfirm"
      @submit="submit"
    />
  </div>
</template>
